import { createClient } from "@supabase/supabase-js";
import { config } from "./config";

export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: { flowType: "implicit", persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
